import React, { Component } from 'react';
import { GraingerAccountContext } from '../../Context/Context';

import './Home.scss'
import Page from '../../Components/Page/Page'
import Street from '../../Assets/home-banner.jpg'

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  render() {
    return (
      <Page title='Home' type='Custom'>
        <div className='home-container'>
          <div className='home-banner'>
            <img className='home-image no-select' src={Street} alt='Home Page' />
            <div className='banner-corner'>
              <div className='banner-corner-text'>"Client Focused Accounting"</div>
            </div>
          </div>
          <div className='home-text'>
            <h2 className='page-title'>"Grainger Accounting takes a personal interest in you the client."</h2>
          </div>
        </div>
      </Page>
    );
  }
}

Home.contextType = GraingerAccountContext;
export default Home;